import React, { useState, useEffect } from 'react';
import { KeyboardTimePicker } from "@material-ui/pickers";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { toast } from 'react-toastify';
import { fr } from "date-fns/locale";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { blockInvalidChar } from "../../components/blockInvalidChar";
import { AjouteInformation, AfficheInformation, AfficheConger } from '../../Api/RestaurantApi/InformationApi';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';
import './css/informationResto.css';

const Information = () => {
  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState(false);
  const [du, setDu] = useState(new Date());
  const [au, setAu] = useState(new Date());
  const [fermeture, setFermeture] = useState([]);
  const [errorFermetureDu, setErrorFermetureDu] = useState("");
  const [errorFermetureAu, setErrorFermetureAu] = useState("");

  let location = useLocation();


  const createDateFromTextValue = (value) => {
    const splitParts = value.split(":");
    return new Date(2022, 1, 1, splitParts[0], splitParts[1]);
  };


  const [info, setInfo] = useState([{
    id: 1,
    service: "petitDejeuner",
    heureDebut: "",
    debut: createDateFromTextValue("00:00"),
    errorDebut: "",
    heureFin: "",
    fin: createDateFromTextValue("00:00"),
    errorFin: "",
    capaciter: 0
  },
  {
    id: 2,
    service: "dejeuner",
    heureDebut: "",
    debut: createDateFromTextValue("00:00"),
    errorDebut: "",
    heureFin: "",
    fin: createDateFromTextValue("00:00"),
    errorFin: "",
    capaciter: 0
  },
  {
    id: 3,
    service: "diner",
    heureDebut: "",
    debut: createDateFromTextValue("00:00"),
    errorDebut: "",
    heureFin: "",
    fin: createDateFromTextValue("00:00"),
    errorFin: "",
    capaciter: 0
  },
  ]);




  const [pdejeuner, setPdejeuner] = useState([
    {
      id: 1,
      status: false,
      libelle: "Lundi",
    },
    {
      id: 2,
      status: false,
      libelle: "Mardi",

    },
    {
      id: 3,
      status: false,
      libelle: "Mercredi",
    },
    {
      id: 4,
      status: false,
      libelle: "Jeudi",

    },
    {
      id: 5,
      status: false,
      libelle: "Vendredi",
    },
    {
      id: 6,
      status: false,
      libelle: "Samedi",
    },
    {
      id: 7,
      status: false,
      libelle: "Dimanche",
    }
  ]);




  const [dejeuner, setDejeuner] = useState([
    {
      id: 1,
      status: false,
      libelle: "Lundi",
    },
    {
      id: 2,
      status: false,
      libelle: "Mardi",

    },
    {
      id: 3,
      status: false,
      libelle: "Mercredi",
    },
    {
      id: 4,
      status: false,
      libelle: "Jeudi",

    },
    {
      id: 5,
      status: false,
      libelle: "Vendredi",
    },
    {
      id: 6,
      status: false,
      libelle: "Samedi",
    },
    {
      id: 7,
      status: false,
      libelle: "Dimanche",
    }
  ]);



  const [diner, setDiner] = useState([
    {
      id: 1,
      status: false,
      libelle: "Lundi",
    },
    {
      id: 2,
      status: false,
      libelle: "Mardi",

    },
    {
      id: 3,
      status: false,
      libelle: "Mercredi",
    },
    {
      id: 4,
      status: false,
      libelle: "Jeudi",

    },
    {
      id: 5,
      status: false,
      libelle: "Vendredi",
    },
    {
      id: 6,
      status: false,
      libelle: "Samedi",
    },
    {
      id: 7,
      status: false,
      libelle: "Dimanche",
    }
  ]);

  const restaurant = useSelector((state) => state.restaurant);




  useEffect(() => {
    Information();
    Fermeture();
  }, []);

  const Information = () => {
    setLoadData(true);
    AfficheInformation(restaurant.id).then(function (response) {
      console.log("data =>", response.data.donner);
      response.data.donner.forEach((el) => {
        setInfo((prev) => {
          return prev.map((item) => {
            if (item.service === el.service) {
              return {
                ...item, heureDebut: el.heureDebut === "" ? "00:00" : new Date(el.heureDebut).getUTCHours() + ':' + new Date(el.heureDebut).getMinutes(), debut: createDateFromTextValue(el.heureDebut === "" ? "00:00" : new Date(el.heureDebut).getUTCHours() + ':' + new Date(el.heureDebut).getMinutes()),
                errorDebut: "", heureFin: el.heureFin === "" ? "00:00" : new Date(el.heureFin).getUTCHours() + ':' + new Date(el.heureFin).getMinutes(), fin: createDateFromTextValue(el.heureFin === "" ? "00:00" : new Date(el.heureFin).getUTCHours() + ':' + new Date(el.heureFin).getMinutes()), errorFin: "",
                capaciter: el.capaciter
              };
            } else {
              return { ...item };
            }
          });
        });

        if (el.service === "petitDejeuner") {

          el.ouvertures.forEach((ouverture) => {
            setPdejeuner((prev) => {
              return prev.map((item) => {
                if (item.libelle === ouverture.libelle) {
                  return { ...item, status: true };
                } else {
                  return { ...item };
                }
              })
            })
          });
        } else if (el.service === "dejeuner") {
          el.ouvertures.forEach((ouverture) => {
            setDejeuner((prev) => {
              return prev.map((item) => {
                if (item.libelle === ouverture.libelle) {
                  return { ...item, status: true };
                } else {
                  return { ...item };
                }
              })
            })
          });
        } else {
          el.ouvertures.forEach((ouverture) => {
            setDiner((prev) => {
              return prev.map((item) => {
                if (item.libelle === ouverture.libelle) {
                  return { ...item, status: true };
                } else {
                  return { ...item };
                }
              })
            })
          });
        }


      });
      console.log("data =>", response.data.donner);

    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadData(false);
    });
  }

  const format = (datet) => {
    let date = new Date(datet);
    return dateFormat(date?.getDate()) + "-" + dateFormat(parseInt(date.getMonth() + 1)) + "-" + date.getFullYear();
  }

  const Fermeture = () => {
    AfficheConger(restaurant.id).then(function (response) {
      console.log(response.data.donner);
      response.data.donner.forEach((el, index) => {
        setFermeture((prev) => [...prev,
        { id: index + 1, du: format(el.du), au: format(el.au) }]);
      });

    }).catch(function (error) {
      console.log(error);
    });
  }




  const handleChangeJourPdejeuner = (id) => {
    setPdejeuner((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, status: !item.status }
        } else {
          return { ...item }
        }
      });
    })
  }


  const handleChangeJourDejeuner = (id) => {
    setDejeuner((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, status: !item.status }
        } else {
          return { ...item }
        }
      });
    })
  }

  const handleChangeJourDiner = (id) => {
    setDiner((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, status: !item.status }
        } else {
          return { ...item }
        }
      });
    })
  }


  const handleHeureDebutChange = (id, date) => {

    setInfo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, heureDebut: date?.getHours() + ':' + date?.getMinutes(), debut: createDateFromTextValue(date?.getHours() + ':' + date?.getMinutes()), errorDebut: "" };
        } else {
          return { ...item };
        }
      });
    });
  }


  const handleHeureFinChange = (id, date) => {
    setInfo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, heureFin: date?.getHours() + ':' + date?.getMinutes(), fin: createDateFromTextValue(date?.getHours() + ':' + date?.getMinutes()), errorFin: "" };
          // if (date?.getMinutes() !== 30 && date?.getMinutes() !== 0) {
          //   return { ...item, errorFin: "L'heure doit être pile ou plus de 30 min" };
          // } else {
          //   return { ...item, heureFin: date?.getHours() + ':' + date?.getMinutes(), fin: createDateFromTextValue(date?.getHours() + ':' + date?.getMinutes()), errorFin: "" };
          // }
        } else {
          return { ...item };
        }
      });
    });
  }


  const handleChangeCapaciter = (id, value) => {
    setInfo((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return { ...item, capaciter: value };
        } else {
          return { ...item };
        }
      });
    });
  }

  const dateFormat = (date) => {
    if (date < 10) {
      return '0' + date;
    } else {
      return date;
    }
  }

  const handleAddFermeture = () => {
    if (!localStorage.getItem('tokenSociete')) {
      console.log(du, au);
      if (fermeture.length < 10) {
        if (du === null && au === null) {
          setErrorFermetureDu('Donner obligatoire');
          setErrorFermetureAu('Donner obligatoire');
          const timer = setTimeout(() => {
            setErrorFermetureDu('')
            setErrorFermetureAu('')
          }, 3000);
          return () => clearTimeout(timer);
        } else if (du !== null && au === null) {
          setErrorFermetureAu('Donner obligatoire');
          const timer = setTimeout(() => {
            setErrorFermetureAu('')
          }, 3000);
          return () => clearTimeout(timer);
        } else if (du === null && au !== null) {
          setErrorFermetureDu('Donner obligatoire');
          const timer = setTimeout(() => {
            setErrorFermetureDu('')
          }, 3000);
          return () => clearTimeout(timer);
        } else {
          setFermeture((prev) => [...prev,
          { id: fermeture.length + 1, du: dateFormat(du?.getDate()) + "-" + dateFormat(parseInt(du.getMonth() + 1)) + "-" + du.getFullYear(), au: dateFormat(au?.getDate()) + "-" + dateFormat(parseInt(au.getMonth() + 1)) + "-" + au.getFullYear() }]);
          setDu(new Date());
          setAu(new Date());
        }
      }
    } else {
      toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
    }
  }

  const handleDeleteFermeture = (id) => {
    if (du === "" && au === "") {
      setErrorFermetureDu("Date oubligatoir !");
      const timer = setTimeout(() => setErrorFermetureDu(''), 3000);
      return () => clearTimeout(timer);
    } else {
      setFermeture(fermeture.filter((el) => el.id !== id));
    }

  }





  const handleEnregistrer = () => {
    if (!localStorage.getItem('tokenSociete')) {
      const dataPdejeuner = pdejeuner.filter((el) => el.status === true);
      const dataDejeuner = dejeuner.filter((el) => el.status === true);
      const dataDiner = diner.filter((el) => el.status === true);
      setLoading(true);
      const data = {
        idRestaurant: restaurant.id, info: info, petitDejeuner: dataPdejeuner, dejeuner: dataDejeuner, diner: dataDiner, fermeture: fermeture
      };
      AjouteInformation(data).then(function (response) {
        if (response.data.title === "success") {
          toast.success(response.data?.message);
          Information();
          Fermeture();
        }
      }).catch(function (error) {
        console.log(error.response);
        toast.warning(error.response.data?.message);
      }).finally(function () {
        setFermeture([]);
        setLoading(false);
      });
    } else {
      toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
    }
  }

  const handleCancel = () => {
    setFermeture([]);
    Information();
    Fermeture();
  }
  console.log("info =>", info);

  return (
    <div>
      <Helmet>
        <title>Information</title>
        <meta name='description' content='Restaurant information .' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='information'>
        <div className='container'>
          <div className='bloc_information'>
            <div className='information_titre'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-id-card-o'></i> <h1>Informations générales</h1>
              </div>
              <div className='information_renseignement'>
                <p>Paramétrage des services, des jours et heures d’ouverture, ainsi que les congés et fermetures exceptionnelles.
                  Dès connaissance, et au plus tôt, pensez à saisir les jours de fermeture afin d’éviter la prise de réservation sur ces créneaux.
                  Veillez à mettre à jour cette page lors de vos changements liés aux services et/ou heure et jour d’ouverture.
                </p>
              </div>
            </div>
            <div className='information_content'>
              <div className='d-flex mt-2 titre'>
                <i className='fa fa-calendar-check-o'></i>   <h2>Jours et heures d’ouverture, hors congés et fermetures exceptionnelles :</h2>
              </div>
              <div className='ajoute_information'>
                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                  <div className='row'>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 d-flex justify-content-center'>
                      <div className='bloc_service'>
                        <div className="service_title">
                          <h3 className='text-center'>Petit déjeuner</h3>
                          <i className="fa fa-cutlery"></i>
                        </div>
                        <div className="service_heure">
                          <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                            <div className="d-flex flex-column">
                              <KeyboardTimePicker
                                label="Heure début"
                                placeholder="08:00"

                                ampm={false}
                                name="heureDebut"
                                value={info[0].debut}
                                onChange={date => handleHeureDebutChange(info[0].id, date)}
                              />
                              {info[0].errorDebut !== "" ? <span className='errorValue  mt-1'>{info[0].errorDebut}</span> : ""}
                            </div>
                            <div className="d-flex flex-column">
                              <KeyboardTimePicker
                                label="Heure fin"
                                placeholder="08:00"

                                ampm={false}
                                name="heureFin"
                                value={info[0].fin}
                                onChange={date => handleHeureFinChange(info[0].id, date)}
                              />
                              {info[0].errorFin !== "" ? <span className='errorValue  mt-1'>{info[0].errorFin}</span> : ""}
                            </div>
                          </MuiPickersUtilsProvider>

                        </div>
                        <div className="d-flex justify-content-center">
                          <div className="capaciter">
                            <div className="input-group mb-3">
                              <span className="input-group-text" id="basic-addon1">Capacité/jour</span>
                              <input type="number" onKeyDown={blockInvalidChar} value={info[0].capaciter} onChange={(e) => handleChangeCapaciter(info[0].id, e.target.value)} className="form-control" placeholder="capaciter..." aria-label="Capaciter" aria-describedby="basic-addon1" />
                            </div>
                          </div>
                        </div>
                        <div className='ouverture'>
                          <h6 className='text-center'>Ouverture</h6>
                          <div className='ouverture_libeller d-flex justify-content-between'>
                            <span>Lu</span>
                            <span>Ma</span>
                            <span>Me</span>
                            <span>Je</span>
                            <span>Ve</span>
                            <span>Sa</span>
                            <span>Di</span>
                          </div>
                          <div className='ouverture_check d-flex justify-content-between'>
                            {pdejeuner.map((el, index) => {
                              return (
                                <div className="form-check " key={index}>
                                  <input className="form-check-input" type="checkbox" onChange={() => handleChangeJourPdejeuner(el.id)} checked={el.status} />
                                </div>
                              );
                            })}


                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4  d-flex justify-content-center'>
                      <div className='bloc_service'>
                        <div className="service_title">
                          <h3 className='text-center'>Déjeuner</h3>
                          <i className="fa fa-cutlery"></i>
                        </div>
                        <div className="service_heure">
                          <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                            <div className="d-flex flex-column">
                              <KeyboardTimePicker
                                label="Heure début"
                                placeholder="08:00"
                                ampm={false}
                                name="heureDebut"

                                value={info[1].debut}
                                onChange={date => handleHeureDebutChange(info[1].id, date)}
                              />
                              {info[1].errorDebut !== "" ? <span className='errorValue mt-1'>{info[1].errorDebut}</span> : ""}
                            </div>
                            <div className="d-flex flex-column">
                              <KeyboardTimePicker
                                label="Heure fin"
                                placeholder="08:00"
                                ampm={false}

                                value={info[1].fin}
                                name="heureFin"
                                onChange={date => handleHeureFinChange(info[1].id, date)}
                              />
                              {info[1].errorFin !== "" ? <span className='errorValue ms-1 mt-1'>{info[1].errorFin}</span> : ""}
                            </div>
                          </MuiPickersUtilsProvider>
                        </div>
                        <div className="d-flex justify-content-center">
                          <div className="capaciter">
                            <div className="input-group mb-3">
                              <span className="input-group-text" id="basic-addon1">Capacité/jour</span>
                              <input type="number" onKeyDown={blockInvalidChar} value={info[1].capaciter} onChange={(e) => handleChangeCapaciter(info[1].id, e.target.value)} className="form-control" placeholder="capaciter..." aria-label="Capaciter" aria-describedby="basic-addon1" />
                            </div>
                          </div>
                        </div>
                        <div className='ouverture'>
                          <h6 className='text-center'>Ouverture</h6>
                          <div className='ouverture_libeller d-flex justify-content-between'>
                            <span>Lu</span>
                            <span>Ma</span>
                            <span>Me</span>
                            <span>Je</span>
                            <span>Ve</span>
                            <span>Sa</span>
                            <span>Di</span>
                          </div>
                          <div className='ouverture_check d-flex justify-content-between'>

                            {dejeuner.map((el, index) => {
                              return (
                                <div className="form-check " key={index}>
                                  <input className="form-check-input" type="checkbox" onChange={() => handleChangeJourDejeuner(el.id)} checked={el.status} />
                                </div>
                              );
                            })}

                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4  d-flex justify-content-center'>
                      <div className='bloc_service'>
                        <div className="service_title">
                          <h3 className='text-center'>Diner</h3>
                          <i className="fa fa-cutlery"></i>
                        </div>

                        <div className="service_heure">
                          <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                            <div className="d-flex flex-column">
                              <KeyboardTimePicker
                                label="Heure début"
                                placeholder="08:00"

                                ampm={false}
                                name="heureDebut"
                                value={info[2].debut}
                                onChange={date => handleHeureDebutChange(info[2].id, date)}
                              />
                              {info[2].errorDebut !== "" ? <span className='errorValue  mt-1'>{info[2].errorDebut}</span> : ""}
                            </div>

                            <div className="d-flex flex-column">
                              <KeyboardTimePicker
                                label="Heure fin"
                                placeholder="08:00"
                                name="heureFin"
                                ampm={false}
                                value={info[2].fin}
                                onChange={date => handleHeureFinChange(info[2].id, date)}
                              />
                              {info[2].errorFin !== "" ? <span className='errorValue  mt-1'>{info[2].errorFin}</span> : ""}
                            </div>
                          </MuiPickersUtilsProvider>

                        </div>
                        <div className="d-flex justify-content-center">
                          <div className="capaciter">
                            <div className="input-group mb-3">
                              <span className="input-group-text" id="basic-addon1">Capacité/jour</span>
                              <input type="number" onKeyDown={blockInvalidChar} value={info[2].capaciter} onChange={(e) => handleChangeCapaciter(info[2].id, e.target.value)} className="form-control" placeholder="capaciter..." aria-label="Capaciter" aria-describedby="basic-addon1" />
                            </div>
                          </div>
                        </div>
                        <div className='ouverture'>
                          <h6 className='text-center'>Ouverture</h6>
                          <div className='ouverture_libeller d-flex justify-content-between'>
                            <span>Lu</span>
                            <span>Ma</span>
                            <span>Me</span>
                            <span>Je</span>
                            <span>Ve</span>
                            <span>Sa</span>
                            <span>Di</span>
                          </div>
                          <div className='ouverture_check d-flex justify-content-between'>

                            {diner.map((el, index) => {
                              return (
                                <div className="form-check " key={index}>
                                  <input className="form-check-input" type="checkbox" onChange={() => handleChangeJourDiner(el.id)} checked={el.status} />
                                </div>
                              );
                            })}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='conger'>
                <div className='d-flex mt-2 titre'>
                  <i className='fa fa-calendar-plus-o'></i>  <h2>Congés et fermetures exceptionnelles :</h2>
                </div>

                <div className='ajoute_conger mt-2'>
                  <div className='d-flex fermeture_flex'>
                    <span className='lettre me-2'>Du</span>
                    <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                      <div className='d-flex flex-column'>
                        <KeyboardDatePicker
                          value={du}
                          placeholder="10/10/2018"
                          onChange={date => setDu(date)}
                          minDate={new Date()}
                          format="dd/MM/yyyy"
                        />
                        {errorFermetureDu !== "" ? <span className='errorValue ms-1  mt-1'>{errorFermetureDu}</span> : ""}
                      </div>

                      <span className='lettre mx-2'>au</span>
                      <div className='d-flex flex-column'>
                        <KeyboardDatePicker
                          value={au}
                          placeholder="10/10/2018"
                          onChange={date => setAu(date)}
                          minDate={new Date()}
                          format="dd/MM/yyyy"
                        />
                        {errorFermetureAu !== "" ? <span className='errorValue ms-1 mt-1'>{errorFermetureAu}</span> : ""}
                      </div>
                    </MuiPickersUtilsProvider>
                    <button className='btn btn-sm btn-ajoute_date' onClick={handleAddFermeture}><i className='fa fa-calendar-plus-o'></i></button>
                  </div>
                </div>
                <div className='liste_conger'>
                  {loadData === true ?
                    <div className="d-flex justify-content-center">
                      <Spinner animation="border" className="load" variant="info" size="md" />
                    </div>
                    : fermeture?.length !== 0 ?
                      fermeture.map((fermeture, index) => {
                        return (
                          <div className='d-flex mt-3' key={index}>
                            <div><span>- Fermeture du {fermeture.du} au {fermeture.au} </span></div>
                            <span onClick={() => handleDeleteFermeture(fermeture.id)}><i className='fa fa-trash-o'></i></span>
                          </div>
                        )
                      })
                      : ''}
                </div>

              </div>
              <div className='action'>
                <div className='d-flex justify-content-center'>
                  <button className='btn btn_annuler' onClick={handleCancel}>Annuler</button>
                  {loading ? <Button className='btn btn_ajouteInformation' disabled>
                    <Spinner

                      animation="border"
                      size="sm"
                      variant="info"
                    />
                    Loading...
                  </Button> : <button className='btn' onClick={handleEnregistrer}>Enregistrer</button>}

                </div>
              </div>
              <p className='version'>Version 1</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Information